import React from 'react';
import { Paper, Typography, Box, Divider, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

/**
 * Renders any timeline / history events the API exposes on a return.
 * Falls back gracefully if no events are present.
 */
const ReturnTimeline = ({ events = [] }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    if (!events || events.length === 0) return null;

    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 2, md: 3 },
                borderRadius: 3,
                border: (t) => `1px solid ${t.palette.divider}`,
                mb: 3,
            }}
        >
            <Typography variant="h6" fontWeight={700} mb={2}>
                {isArabic ? 'سجل الأحداث' : 'Timeline'}
            </Typography>

            <Stack divider={<Divider flexItem />} spacing={1.5}>
                {events.map((ev) => (
                    <Box key={ev.id} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="body2" fontWeight="medium">
                            {ev.description || ev.event}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {dayjs(ev.created_at).format('YYYY-MM-DD HH:mm')}
                            {ev.actor?.name ? ` • ${ev.actor.name}` : ''}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </Paper>
    );
};

export default ReturnTimeline;
